// emoji.js
import Vue from "vue";

// 防抖函数
const debounce = (fn, delay = 200) => {
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

// 禁止输入特殊字符
Vue.directive("emoji", {
  bind: function (el, binding, vnode) {
    // 修改正则规则，添加全局匹配标志 g，将空格改为连续匹配
    const regRule =
      /[`~^!@#$€£₤%^&*\+=<>?"|\;'~！……@#￥¥%*\+|《》？“”‘']|\s+/gim;
    let $inp = findEle(el, "input") || findEle(el, "textarea");
    el.$inp = $inp;
    let isComposing = false; // 标记是否正在进行中文输入

    const originalHandle = function (event) {
      if (isComposing) return; // 如果正在进行中文输入，不做处理
      let val = $inp.value;
      console.log("处理前的值:", val);
      $inp.value = val.replace(regRule, "");
      console.log("处理后的值:", $inp.value);
      trigger($inp, "input");
    };

    $inp.handle = debounce(originalHandle);
    $inp.addEventListener("keyup", $inp.handle);

    // 监听中文输入开始事件
    $inp.addEventListener("compositionstart", () => {
      isComposing = true;
    });

    // 监听中文输入结束事件
    $inp.addEventListener("compositionend", () => {
      isComposing = false;
      $inp.handle();
    });
  },
  unbind: function (el) {
    let $inp = el.$inp;
    $inp.removeEventListener("keyup", $inp.handle);
    $inp.removeEventListener("compositionstart", () => {});
    $inp.removeEventListener("compositionend", () => {});
  },
});

const findEle = (parent, type) => {
  return parent.tagName.toLowerCase() === type
    ? parent
    : parent.querySelector(type);
};

const trigger = (el, type) => {
  const e = document.createEvent("HTMLEvents");
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
